import { useUserReviews } from '@/scopes/products/user-reviews/hooks'
import React from 'react'
import { styled } from 'styled-components'
import { Filters } from '../Filters/Filters'
import { Heading } from './Heading'
import { List } from './List'

const Wrapper = styled.div``

export function Result() {
  const { isLoading } = useUserReviews()

  if (isLoading) {
    return 'Loading...'
  }

  return (
    <Wrapper>
      <Heading />
      <Filters />
      <List />
    </Wrapper>
  )
}

Result.Wrapper = Wrapper
